import Fetch from "utils/fetch";

export const anticipateDelayOrder = (anticipateDelayOrderRequest) => {
  return Fetch.post(`/orders/${anticipateDelayOrderRequest.orderId}:anticipate-delay`, anticipateDelayOrderRequest).then(({ data }) => data)
};